import { defineStore } from 'pinia'
import { useSessionStorage } from '@vueuse/core'
import type { LocationQuery } from 'vue-router'

interface QueryCache {
  [routePath: string]: LocationQuery
}

/**
 * Store pour gérer le cache des query parameters des routes
 * Utilise sessionStorage pour un cache limité à la session
 */
export const useQueryCacheStore = defineStore('queryCache', () => {
  // Utilise useSessionStorage de VueUse pour la réactivité
  const cache = useSessionStorage<QueryCache>('naboo_route_query_cache', {})

  /**
   * Sauvegarde les query params d'une route
   */
  function set(path: string, query: LocationQuery): void {
    cache.value[path] = query
  }

  /**
   * Récupère les query params d'une route
   * Retourne null si absent
   */
  function get(path: string): LocationQuery | null {
    return cache.value[path] || null
  }

  /**
   * Supprime les query params d'une route
   */
  function remove(path: string): void {
    delete cache.value[path]
  }

  /**
   * Vide complètement le cache
   */
  function clear(): void {
    cache.value = {}
  }

  return {
    set,
    get,
    remove,
    clear
  }
})
